import * as firebase from 'firebase/app'

import 'firebase/database'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/functions'

// firebase init - add your own config here
const firebaseConfig = {
    apiKey: "AIzaSyDOuPx2XWKPheCCd_c6WpalLY0r1Jn1e0M",
    authDomain: "logis-des-clos.firebaseapp.com",
    databaseURL: "https://logis-des-clos.firebaseio.com",
    projectId: "logis-des-clos",
    storageBucket: "logis-des-clos.appspot.com",
    messagingSenderId: "1015809769608",
    appId: "1:1015809769608:web:85f319c215be45ccd51f3d",
    measurementId: "G-8SG07LZF4S"
  };
firebase.initializeApp(firebaseConfig)

const firestore = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.functions();
const analytics =  firebase.analytics();

export {
  firestore,
  functions,
    storage,
    auth
}